var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWhp(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 2279.344,
    height: 1238.505,
    viewBox: "0 0 2279.344 1238.505",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n      }\n\n      .cls-11, .cls-2 {\n        fill: #f5f3f0;\n      }\n\n      .cls-3 {\n        clip-path: url(#clip-path);\n      }\n\n      .cls-10, .cls-4 {\n        fill: #3f3030;\n      }\n\n      .cls-5 {\n        clip-path: url(#clip-path-2);\n      }\n\n      .cls-6 {\n        fill: #ebe5dc;\n      }\n\n      .cls-7 {\n        fill: #887e7d;\n      }\n\n      .cls-8 {\n        fill: #866c5c;\n      }\n\n      .cls-9 {\n        fill: #372121;\n      }\n\n      .cls-10, .cls-11 {\n        opacity: 0.4;\n      }\n\n      .cls-12 {\n        fill: #e9f3fe;\n      }\n\n      .cls-13 {\n        fill: #c65447;\n      }\n\n      .cls-14 {\n        fill: #ffd5b7;\n      }\n\n      .cls-15 {\n        fill: #e2915a;\n      }\n\n      .cls-16 {\n        fill: #3a2525;\n      }\n\n      .cls-17 {\n        fill: #111;\n      }\n\n      .cls-18 {\n        fill: #fcecdb;\n      }\n\n      .cls-19 {\n        fill: #af9585;\n      }\n\n      .cls-20 {\n        fill: #f4d2b8;\n      }\n\n      .cls-21 {\n        fill: #2e2222;\n      }\n\n      .cls-22 {\n        fill: #322222;\n      }\n\n      .cls-23 {\n        fill: #ebf3ff;\n      }\n\n      .cls-24 {\n        fill: #00284b;\n      }\n\n      .cls-25 {\n        clip-path: url(#clip-path-3);\n      }\n\n      .cls-26 {\n        opacity: 0.1;\n      }\n\n      .cls-27 {\n        fill: #263238;\n      }\n\n      .cls-28 {\n        fill: #455a64;\n      }\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_169",
    "data-name": "Rectangle 169",
    className: "cls-1",
    width: 174.517,
    height: 174.517
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_170",
    "data-name": "Rectangle 170",
    className: "cls-1",
    width: 1992.87,
    height: 1041.469
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_171",
    "data-name": "Rectangle 171",
    className: "cls-1",
    width: 361,
    height: 840,
    transform: "translate(-0.233 0.013)"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_20013",
    "data-name": "Group 20013",
    transform: "translate(17703.344 279.213)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_20012",
    "data-name": "Group 20012",
    transform: "translate(-17710.344 -279.214)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_744",
    "data-name": "Path 744",
    className: "cls-2",
    d: "M137.4,1237.883S-137.879,942.956,90.847,623.65C293.788,340.34,530.4,359.707,703.995,474.674c73.934,48.967,287.1,6.036,468.537-282.242C1419.955-200.7,2277.617,37.738,2121.238,642.582c-75.674,292.7,230.313,303.341,74.4,595.923Z",
    transform: "translate(7 0)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_20009",
    "data-name": "Group 20009",
    className: "cls-3",
    transform: "translate(1283.545 281.478)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_20008",
    "data-name": "Group 20008",
    transform: "translate(7.267 14.543)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_745",
    "data-name": "Path 745",
    className: "cls-4",
    d: "M321.3,153.658a7.123,7.123,0,0,0-1.675-7.635l-15.195-14.979.218-.218a127.418,127.418,0,0,0,26.98-47.483h14.1a7.264,7.264,0,0,0,7.2-7.2V76a7.264,7.264,0,0,0-7.2-7.2h-43.7V61.528a7.27,7.27,0,1,0-14.54,0V68.8h-43.7a7.2,7.2,0,1,0,0,14.4H317.81a113.837,113.837,0,0,1-23.051,39.048A112.774,112.774,0,0,1,279.782,101.3a6.437,6.437,0,0,0-5.674-3.418,6.6,6.6,0,0,0-5.745,9.817,128.4,128.4,0,0,0,16.728,23.341l-31.776,31.341a7.2,7.2,0,0,0,0,10.325,7.326,7.326,0,0,0,10.323,0l31.121-31.2L309.452,156.2A7.221,7.221,0,0,0,321.3,153.658Zm35.267-41.229a10.436,10.436,0,0,0-9.815,6.835l-26.691,71.261a6.742,6.742,0,0,0,6.329,9.162,6.834,6.834,0,0,0,6.4-4.435l6.471-17.379H373.8l6.542,17.379a6.941,6.941,0,0,0,6.4,4.435,6.809,6.809,0,0,0,6.4-9.162l-26.691-71.261A10.6,10.6,0,0,0,356.569,112.429Zm-11.779,50.9,11.779-31.486,11.779,31.486Z",
    transform: "translate(-236.587 -54.256)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_20010",
    "data-name": "Group 20010",
    className: "cls-5",
    transform: "translate(61.925 180.146)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_746",
    "data-name": "Path 746",
    className: "cls-6",
    d: "M203.3,162.128,40,311.927l150.2,162.861L353.5,324.983Z",
    transform: "translate(116.335 542.292)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_747",
    "data-name": "Path 747",
    className: "cls-7",
    d: "M203.3,162.128,40,311.927l30.252,32.8,163.294-149.8Z",
    transform: "translate(116.335 542.292)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_748",
    "data-name": "Path 748",
    className: "cls-4",
    d: "M157.311,72.8l111.94,15.926-74.283-50.5-3.776,16.185-27.22,4.917Z",
    transform: "translate(639.048 -9.804)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_749",
    "data-name": "Path 749",
    className: "cls-8",
    d: "M328.477,90.343l-93.155-47.9-91.3-4.58Z",
    transform: "translate(579.828 -11.424)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_750",
    "data-name": "Path 750",
    className: "cls-8",
    d: "M164,61.423l74.283,50.5L180.777,33Z",
    transform: "translate(668.854 -33.099)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_751",
    "data-name": "Path 751",
    className: "cls-4",
    d: "M279.415,131.81l-9.16,6.558-9.21-6.487a11.3,11.3,0,0,1,18.37-.071Z",
    transform: "translate(1101.284 386.31)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_752",
    "data-name": "Path 752",
    className: "cls-4",
    d: "M280.936,124.2a27.222,27.222,0,0,0-22.288,11.55l5.816,4.07a20.176,20.176,0,0,1,32.85-.12l5.789-4.141A27.252,27.252,0,0,0,280.936,124.2Z",
    transform: "translate(1090.603 373.263)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_753",
    "data-name": "Path 753",
    className: "cls-4",
    d: "M301.25,118.628a57.645,57.645,0,0,0-47.161,24.432l5.811,4.07a50.649,50.649,0,0,1,82.483-.311l5.767-4.141a57.648,57.648,0,0,0-46.9-24.05Z",
    transform: "translate(1070.288 348.457)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_754",
    "data-name": "Path 754",
    className: "cls-4",
    d: "M290.2,121.674A41.234,41.234,0,0,0,256.568,139l5.816,4.07a34.216,34.216,0,0,1,55.493-.213l5.772-4.119A41.256,41.256,0,0,0,290.2,121.674Z",
    transform: "translate(1081.335 362.03)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_755",
    "data-name": "Path 755",
    className: "cls-4",
    d: "M821.48,433.631l-25.818-.589c8.3,10.721,10.159,20.6,4.992,28.949-5.161,8.528-17.519,15.533-35.971,20.853A333.418,333.418,0,0,0,307.906,66.786l-.044.021c-14.339-4.363-28.305-7.94-41.78-10.663-68.021-13.771-116.294-4.253-135.9,26.791-18.661,29.525-8.5,73.966,28.525,125.8l-.014.025a334.464,334.464,0,0,0-22.09,50.646C67.032,263.545,29.791,275.756,16.25,297.872c-15.742,25.745,5.756,60.3,74.564,93.894,9.479,4.644,19.635,9.205,30.3,13.761,8.243,72.232,41.236,142.248,95.385,196.251a334.473,334.473,0,0,0,105.964,71.239c121.6,51.155,266.56,27.2,365.543-71.239a331.094,331.094,0,0,0,70.082-102.643c33.936-7.005,56.284-17.977,65.166-32.5C829.435,456.59,828.671,445.449,821.48,433.631Zm-79.646,54.445c-22.6,4.048-50.779,6.416-83.706,6.754-51.084.617-109.758-3.4-171.591-11.534q7.805-16.941,15.278-34.771a473.712,473.712,0,0,0,55.569,15.064c20.345,4.119,38.912,6.154,55.482,6.154,38.846,0,66.677-11.185,80.421-32.943a57.152,57.152,0,0,0,5.527-11.4h-19.8c-.327.6-.677,1.195-1.042,1.773-10.208,16.166-33.025,24.514-65.062,24.508-15.32,0-32.763-1.91-51.93-5.789a454.68,454.68,0,0,1-52.3-14.115q7.153-17.841,13.88-36.331c12.069-33.191,22.4-66.095,30.761-97.689,67.736,9.96,138.511,10.259,206.5,5.146a314.334,314.334,0,0,1,6.476,63.706A310.533,310.533,0,0,1,741.834,488.076ZM329.291,652.906c-9.63-3.481-14.52-17.268-16.926-28.218-3.8-17.312-4.489-41.618-1.987-70.3,1.265-14.507,3.3-29.926,6.035-46.059a859.163,859.163,0,0,1,116.63,40.243c-8.574,14.747-17.244,28.42-25.912,40.811C390.614,613,374.462,631.214,360.42,642.065,351.534,648.934,338.922,656.393,329.291,652.906ZM441.762,533.142a877.023,877.023,0,0,0-122.178-42.2q2.187-11.237,4.794-22.844,17.257,3.912,34.985,7.567c34.572,7.049,69.06,13.034,102.817,17.879Q452.154,514.246,441.762,533.142Zm-74.78-69.967q-20.036-4.108-39.459-8.577c6.09-25.277,13.573-51.63,22.307-78.476,45.4,27.834,91.577,50.481,135.3,66.549q-8.227,19.584-16.873,38.115C435.045,476.035,401.073,470.142,366.983,463.175ZM256.094,122c25.234,51.568,73.871,94.054,126.21,122.239-12.68,27.557-24.757,56.966-35.862,87.5q-3.106,8.54-6.052,17.048c-66.33-43.062-122.487-92.472-159.326-140.289l-.015-.02A314.892,314.892,0,0,1,256.094,122Zm283.618-47.72c9.63,3.484,14.524,17.269,16.924,28.223,3.8,17.306,4.49,41.616,1.991,70.3-2.739,31.4-9.046,67.055-18.425,105.024-46.129-7.915-92.226-20.966-134.668-41.51,18.089-37.622,37.216-71.17,56.339-98.511,16.516-23.613,32.669-41.83,46.711-52.683C515.913,79.462,525.772,73.4,534.4,73.4a15.5,15.5,0,0,1,5.309.887Zm-3.9,220.652c-8.146,30.554-18.174,62.377-29.855,94.506q-6.76,18.579-13.967,36.523C448.1,409.9,401.513,386.91,355.713,358.516q3.551-10.351,7.333-20.764c10.855-29.851,22.637-58.581,34.991-85.487,43.228,20.9,90.057,34.382,137.774,42.674ZM674.3,145.116a312.012,312.012,0,0,1,81.409,140.419c-72.384,5.279-138.718,3.622-198.008-4.937,9.406-38.342,15.74-74.41,18.523-106.268,3.066-35.181,2.7-76.851-11.61-100.3a312.21,312.21,0,0,1,109.681,71.09Zm-222-91.752a315.44,315.44,0,0,1,64.065,6.514C491.692,70.588,466.5,100.4,447.385,127.73c-19.568,27.974-39.108,62.211-57.559,100.535-49.807-26.99-96.852-68.367-119.341-117.109A313.525,313.525,0,0,1,452.3,53.364Zm-306.8,39.2c10.21-16.164,33.026-24.506,65.061-24.506,15.322,0,32.764,1.909,51.933,5.789q10.917,2.2,22.273,5.188l.019.005A334.6,334.6,0,0,0,168.767,191.46l-.016.026C140.439,149.566,131.931,114.022,145.5,92.562Zm26.147,133.253.008-.016c38.791,48.355,95.965,97.788,162.769,140.66-9.473,28.751-17.554,57.007-24.076,84.091-55.388-13.367-119.765-32.267-170.608-53.719A311.136,311.136,0,0,1,171.644,225.816ZM106.218,381.8C46.211,352.6,18.789,324.4,31.061,304.4c9.9-16.207,45.957-27.179,101.14-31.231-11.125,37.447-14.994,76.378-12.7,114.882C114.935,386.024,110.534,383.914,106.218,381.8Zm200.965,82.3q-2.567,11.425-4.737,22.506-5.776-1.4-11.56-2.717c-65.141-14.791-114.024-17.8-136.684-18.3A305.5,305.5,0,0,1,141.85,413.88C186.23,430.9,236.185,447.233,307.183,464.108ZM160.767,483.455c24.166.971,68.969,4.621,126.2,17.612q6.142,1.4,12.277,2.9c-2.946,17.132-5.119,33.505-6.461,48.891-2.543,29.157-2.723,62.776,5.431,86.783A315.127,315.127,0,0,1,160.767,483.455ZM357.066,665.2c23.232-12.139,46.574-40.03,64.55-65.733,9.272-13.253,18.538-27.924,27.684-43.757a888.217,888.217,0,0,1,151.088,87.175A315.27,315.27,0,0,1,357.066,665.2Zm317.229-77.1a311.72,311.72,0,0,1-57.119,45.154A906.651,906.651,0,0,0,457.971,540.29c7.656-13.995,15.2-28.775,22.572-44.2,50.985,6.738,100,10.781,144.751,11.828,11.676.333,23.019.333,34.023.251,28.518-.338,53.91-2.024,75.663-5.063a311.2,311.2,0,0,1-60.687,85Z",
    transform: "translate(-11.35 -28.117)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_756",
    "data-name": "Path 756",
    className: "cls-7",
    d: "M169.517,121.078l-46.1,546.716s-4.828,33.145,19.887,33.2c40.642.1,202.28,0,202.28,0S315,694.1,315.366,678.575c.437-18.3,53.883-562.669,53.883-562.669Z",
    transform: "translate(486.307 336.328)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_757",
    "data-name": "Path 757",
    className: "cls-4",
    d: "M347.846,699.18c-7.993.022-162.381.507-201.953,0-17.252-.213-20.274-15.293-20.416-25.054a48.393,48.393,0,0,1,.524-8.14l1.195-14.207,3.061-36.217,2.7-32,3.47-41.116,2.919-34.705L172.1,119.259l199.732-5.172S349.325,341.907,333.4,507.741c-1.773,18.474-3.465,36.195-5.03,52.732q-.761,7.914-1.468,15.468c-1.479,15.691-2.826,30.1-4,42.818-.622,6.705-1.189,12.936-1.708,18.643-2.035,22.364-3.225,36.642-3.241,39.359a22.706,22.706,0,0,0,.387,4.425C321.619,698.613,344.845,699.18,347.846,699.18Z",
    transform: "translate(497.153 328.222)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_758",
    "data-name": "Path 758",
    className: "cls-4",
    d: "M42.648,62.326l112.3,449.879,15.376,61.614,52.3,209.542h971.728L1001.569,62.326Z",
    transform: "translate(128.112 97.575)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_759",
    "data-name": "Path 759",
    className: "cls-9",
    d: "M55.358,62.326,39.795,67.5,214.651,799.015l20.693-15.648Z",
    transform: "translate(115.399 97.575)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_760",
    "data-name": "Path 760",
    className: "cls-9",
    d: "M71.843,210.13h965.744l26.669-15.648H92.535Z",
    transform: "translate(258.206 686.46)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_761",
    "data-name": "Path 761",
    d: "M134,231.279H343.1v-9.913H134Z",
    transform: "translate(535.188 806.254)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_762",
    "data-name": "Path 762",
    className: "cls-4",
    d: "M1145.707,650.5,988.029,71.862H45.728L43,62.326h957L1157.142,649.21Z",
    transform: "translate(129.682 97.575)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_763",
    "data-name": "Path 763",
    className: "cls-7",
    d: "M324.074,197.349l-1.08,7.578-196.65,39.621,2.7-32,1.288-15.2Z",
    transform: "translate(501.06 699.235)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_764",
    "data-name": "Path 764",
    className: "cls-10",
    d: "M347.838,271.781c-7.993.022-162.381.507-201.953,0-17.252-.213-20.274-15.293-20.416-25.054L321.186,210c-2.035,22.364-3.225,36.642-3.241,39.359a23.132,23.132,0,0,0,.393,4.425C321.611,271.214,344.837,271.781,347.838,271.781Z",
    transform: "translate(497.161 755.621)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_765",
    "data-name": "Path 765",
    className: "cls-11",
    d: "M545.22,219.653,118.354,365.623l-52.3-209.548Z",
    transform: "translate(232.387 515.32)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_766",
    "data-name": "Path 766",
    className: "cls-4",
    d: "M42.647,62.326h958.924l155.588,579.486h-974.8Z",
    transform: "translate(128.11 97.575)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_767",
    "data-name": "Path 767",
    className: "cls-1",
    d: "M211.952,202.983c-2.772-14.213-16.57-25.736-30.821-25.736s-23.553,11.523-20.782,25.736,16.564,25.73,30.815,25.73S214.719,217.19,211.952,202.983Z",
    transform: "translate(650.413 609.661)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_768",
    "data-name": "Path 768",
    className: "cls-12",
    d: "M1079.5,591.352H181.65L79.969,187.378,72.177,156.4l-6.653-26.425L60.2,108.821,49.928,68.015H934.834l.617,2.245,10.65,38.561,5.849,21.156,7.316,26.425,8.56,30.977Z",
    transform: "translate(160.55 122.926)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_769",
    "data-name": "Path 769",
    className: "cls-2",
    d: "M1079.5,591.6H181.65L79.969,187.63l-7.792-30.976-6.653-26.425L60.2,109.074,49.928,68.268H934.834l.617,2.245,10.65,38.561,5.849,21.155,7.316,26.425,8.56,30.976Z",
    transform: "translate(160.55 124.054)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_770",
    "data-name": "Path 770",
    className: "cls-2",
    d: "M946.1,108.821H60.2L49.928,68.015H934.491l.96,2.245Z",
    transform: "translate(160.55 122.926)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_771",
    "data-name": "Path 771",
    className: "cls-12",
    d: "M54.636,78.08c-1.07-4.277,1.541-7.745,5.83-7.745a10.611,10.611,0,0,1,9.707,7.745c1.073,4.278-1.541,7.746-5.83,7.746A10.608,10.608,0,0,1,54.636,78.08Z",
    transform: "translate(180.461 133.264)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_772",
    "data-name": "Path 772",
    className: "cls-12",
    d: "M73.722,83.886c2.507-2.832,1.588-7.726-2.052-10.933s-8.624-3.511-11.132-.679S58.95,80,62.591,83.207,71.215,86.718,73.722,83.886Z",
    transform: "translate(201.537 133.264)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_773",
    "data-name": "Path 773",
    className: "cls-12",
    d: "M64.458,78.08C63.389,73.8,66,70.335,70.288,70.335a10.6,10.6,0,0,1,9.7,7.745c1.069,4.278-1.541,7.746-5.83,7.746A10.6,10.6,0,0,1,64.458,78.08Z",
    transform: "translate(224.229 133.264)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_774",
    "data-name": "Path 774",
    className: "cls-4",
    d: "M203.326,437.442h-88.78c-.851-6.924-1.6-14.235-2.275-21.868-1.189-13.684-2.1-28.409-2.777-43.724q-.245-5.295-.431-10.683c-.169-4.567-.316-9.188-.447-13.831q-.327-11.834-.513-23.892a.024.024,0,0,1-.005-.027c-.158-10.23-.235-20.531-.256-30.793v-.006q-.008-3.846-.011-7.677v-.011c0-2.406.011-4.8.016-7.191.076-22.086.409-43.751.884-63.895,1.02-44.575,2.679-81.714,3.557-99.566v-.011c.355-7.327.589-11.4.589-11.4a.08.08,0,0,0,.022.011c.2.027,1.549.273,3.666.786,1.555.376,3.53.895,5.772,1.582h.005c2.03.606,4.267,1.359,6.618,2.248h.011c.005,0,.005.005.011.005a78.119,78.119,0,0,1,12.363,5.958l.186.093c6.629,4.1,12.614,9.542,15.348,16.728,2.346,6.1,7.829,38.9,14.458,82.462q.278,1.858.562,3.754c3.508,23.133,7.295,49.087,11.1,75.587,4.032,28.087,8.064,56.769,11.769,83.351C197.935,398.23,200.865,419.47,203.326,437.442Z",
    transform: "translate(418.562 278.217)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_775",
    "data-name": "Path 775",
    className: "cls-4",
    d: "M215.671,238.063H112.335c-1.981-8.506-3.836-16.706-5.483-24.4-4.542-21.2-7.529-38.574-7.366-47.909a13.971,13.971,0,0,1,4.578-10.432,22.567,22.567,0,0,1,7.4-4.359c8.719-3.3,21.246-3.841,34.356-3.006,4.458.273,8.975.709,13.433,1.249a391.318,391.318,0,0,1,47.358,9.035s1.522,6.149,3.328,16.9c1.353,8.059,2.859,18.725,3.983,31.312.649,7.317,1.173,15.288,1.468,23.777C215.475,232.781,215.567,235.4,215.671,238.063Z",
    transform: "translate(381.354 477.596)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_776",
    "data-name": "Path 776",
    className: "cls-13",
    d: "M209.592,161.527l-1.031,7.447-5,36.157-.851,6.171-3.1,22.413H91.913c-.836-14.813-1.609-29.25-1.756-41.836-.016-1.4-.023-2.761-.023-4.1,0-18.949,1.671-33,7.117-36.544,6.173-4.026,26.65-2.919,48.456-.256q3.265.393,6.553.84c12.712,1.708,25.43,3.814,35.655,5.625,5.309.939,9.941,1.806,13.547,2.493C206.553,160.9,209.592,161.527,209.592,161.527Z",
    transform: "translate(339.71 481.944)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_777",
    "data-name": "Path 777",
    className: "cls-1",
    d: "M90.134,126.041S149.3,87.891,191.73,107.4c6.765,3.11,14.48,11.785,20,17.852,15.337,16.859,45.312,284.633,45.312,284.633s-85.086,28.742-166.91-9.75Z",
    transform: "translate(339.709 273.684)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_778",
    "data-name": "Path 778",
    className: "cls-4",
    d: "M109,103s59.9,24.481,68,43.288,34.482,134.321,34.482,147.862-45.907,3.033-53.3-18.812c-6.138-18.141-26.838-73.868-37.75-109.119Z",
    transform: "translate(423.776 278.819)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_779",
    "data-name": "Path 779",
    className: "cls-14",
    d: "M144.94,149.691c-13.072,2.559-32.278-.169-46.342-9.412,6.349-15.124,8.952-27.063,9.88-34.791.049-.409.093-.809.136-1.194a35.717,35.717,0,0,0,.158-7.97h33.805s9.242,4.214,9.242,7.127q0,2.337.044,4.47c.065,3.877.224,7.261.426,10.167a92.555,92.555,0,0,0,1.73,13.918S158.144,147.111,144.94,149.691Z",
    transform: "translate(377.426 249.079)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_780",
    "data-name": "Path 780",
    className: "cls-15",
    d: "M144.8,113.016c-25.6,4.938-40.472-9.021-43.806-12.6-.475-.512-.715-.818-.715-.818.273-.136.551-.256.851-.378,9.532-3.85,31.17-.789,43.244,3.627C144.444,106.726,144.6,110.11,144.8,113.016Z",
    transform: "translate(384.911 254.153)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_781",
    "data-name": "Path 781",
    className: "cls-14",
    d: "M104.137,145.836c4.575,24.563,36.356,23.757,50.089,22.213,3.868-.429,6.3-.92,6.3-.92,4.359-1.159,6.793-8.007,7.922-16.975,2.242-17.747-.589-43.8-3.6-50.461C160.325,89.668,151.8,78.825,119.8,86.648S98.265,114.363,104.137,145.836Z",
    transform: "translate(373.4 194.027)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_782",
    "data-name": "Path 782",
    className: "cls-16",
    d: "M183.358,102.493c-4.37-6.04-13.645-13.419-22.069-17.965-18.1-9.763-41.26.308-41.356.35-26.141,11.463-32.968,31.41-19.108,62.482,14.655,32.859,28.612,29.16,28.612,29.16s-2.964-1.841-2.7-12.079c.016-.582.039-1.068.068-1.487a6.874,6.874,0,0,0-2.18-5.6c-3.247-2.89-4.83-11.632-2.111-14.066,3.281-2.935,7.89.631,9.364,3.373a3.968,3.968,0,0,0,1.1,1.207,4.028,4.028,0,0,0,4.638.056c8.135-5.13,2.848-15.39,10.623-21.667s23.553-1.007,35.213-6.01C198.716,114.573,186.653,107.045,183.358,102.493Z",
    transform: "translate(356.079 177.526)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_783",
    "data-name": "Path 783",
    className: "cls-4",
    d: "M216.2,438.146H87.38c.92-26.642,2.1-58.455,3.349-90.656.318-8.348.65-16.733.975-25.054.147-3.525.278-7.027.417-10.53,2.847-71.517,5.674-136.1,6.266-139.586,1.354-7.868,2.63-14.573,4.015-20.389,4.046-16.941,9.075-26.232,20.044-34.225,1.068-.808,9.843-5.216,17.567-9.057,6.313-3.126,11.928-5.854,12.1-5.931v-.011h.007c1.277.617,2.685,2.4,4.168,5.025a82.877,82.877,0,0,1,4.648,10.225c5.887,15.08,12.249,38.165,16.663,55.411a.092.092,0,0,1,.016.055.042.042,0,0,1,.011.027v.011c2.843,11.13,4.889,19.794,5.467,22.288.988,4.2,2.286,12.325,3.825,23.324v.033c2.084,15,4.567,35.366,7.2,58.472v.011q.409,3.56.813,7.2.466,4.158.944,8.4v.005c.1.911.2,1.822.295,2.733v.005c1.015,9.155,2.035,18.589,3.044,28.2a.042.042,0,0,0,.011.027c.868,7.917,12.9,13.651,13.738,21.709.06.589.125,1.773.2,3.426.153,3.41.344,8.822.562,15.08.093,2.783.2,5.74.306,8.751.469,13.411,1.053,28.1,1.708,35.169.033.333.06.753.087,1.271.076,1.413.136,3.486.191,6.094C216.129,421.194,216.184,429.116,216.2,438.146Z",
    transform: "translate(327.438 277.513)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_784",
    "data-name": "Path 784",
    className: "cls-16",
    d: "M122.255,120.751c-.038.164-2.05,72.319,52.373,81.087s18.261,11.081,18.261,11.081S90.5,208.576,88.8,205.881,122.255,120.751,122.255,120.751Z",
    transform: "translate(333.509 357.917)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_785",
    "data-name": "Path 785",
    className: "cls-16",
    d: "M181.792,153.223s-1.02.72-2.984,1.981a.954.954,0,0,0-.1.06c-8.3,5.287-32.948,19.7-68.825,29.359q-5.649,1.53-11.669,2.875c.318-8.348.649-16.733.973-25.048A105.963,105.963,0,0,1,85.7,160.583c.142-1.1.291-2.193.433-3.3,4.563-1.866,9.1-3.666,13.474-5.374,3.563-1.386,7.011-2.712,10.276-3.939,14.738-5.581,25.663-9.362,25.663-9.362l43.625,13.782Z",
    transform: "translate(319.956 437.505)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_786",
    "data-name": "Path 786",
    className: "cls-4",
    d: "M220.908,312.013s-5.6,1.4-14.529,3.186a.258.258,0,0,0-.093.022c-16.456,3.3-44.12,7.922-68.833,7.671-3.644-.038-7.227-.18-10.7-.447a105.963,105.963,0,0,1-13.488-1.866c-9.032-1.9-16.6-5.118-21.546-10.143-36.758-37.341,20.059-171.361,32-184.4,13.948-15.222,39.4-20.564,53.457-22.4l1.7-.218c4.942-.584,8.113-.7,8.289-.715h.007s-1.1,3.535-2.947,9.532c-.717,2.313-1.548,5.009-2.461,8.009-8.634,28.2-25.291,83.613-32.634,114.865-2.69,11.441-4.131,19.636-3.474,22.086,2.866,10.672,32.566,16.161,51.382,18.589,7.846,1.009,13.8,1.489,15.135,1.593a2.376,2.376,0,0,1,.278.016l1.086,4.452,2.608,10.672,2.559,10.486Z",
    transform: "translate(292.385 277.509)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_787",
    "data-name": "Path 787",
    className: "cls-1",
    d: "M227.322,285.324l-126.24-5.3,25.61-156.908,126.24,5.3Z",
    transform: "translate(388.493 368.437)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_788",
    "data-name": "Path 788",
    className: "cls-14",
    d: "M109.618,134.919s24.574-1.708,25.807,4c2.875,13.318-21.126,24.252-28.9,23.5S103.965,134.03,109.618,134.919Z",
    transform: "translate(395.223 419.985)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_789",
    "data-name": "Path 789",
    className: "cls-14",
    d: "M149.758,133.163s-23.515-7.333-26.036-2.057c-5.887,12.292,14.928,28.469,22.664,29.533S155.465,133.605,149.758,133.163Z",
    transform: "translate(484.766 395.552)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_790",
    "data-name": "Path 790",
    className: "cls-16",
    d: "M112.391,101.262s-10.339,4.916-15.521,12.33c0,0,38.646,66.918,38.472,66.29S122.28,109.833,112.391,101.262Z",
    transform: "translate(369.723 271.074)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_791",
    "data-name": "Path 791",
    className: "cls-16",
    d: "M108.536,101.435c3.4,1.282,9.935,7.949,11.4,11.638l4.594,58.423s-9.8-42.873-14.8-62.253A32.864,32.864,0,0,1,108.536,101.435Z",
    transform: "translate(421.708 271.845)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_792",
    "data-name": "Path 792",
    className: "cls-17",
    d: "M113.446,126.61s1-4.354,6.744-3.846,38.028,2.09,38.028,2.09,6.231-.1,5.652,3.874Z",
    transform: "translate(443.587 366.702)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_793",
    "data-name": "Path 793",
    className: "cls-1",
    d: "M106.659,99.154a13.511,13.511,0,0,0,10.956,2.63c4-.7,6.253-5.9,6.253-5.9S116.158,94.5,106.659,99.154Z",
    transform: "translate(413.344 246.251)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_794",
    "data-name": "Path 794",
    className: "cls-1",
    d: "M317.15,199.569l-93.248.344L193.665,84.455l93.248-.341Z",
    transform: "translate(801.041 194.662)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_795",
    "data-name": "Path 795",
    className: "cls-4",
    d: "M238.814,88.289l-39.1.144-.447-1.708,39.1-.144Z",
    transform: "translate(826.012 205.656)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_796",
    "data-name": "Path 796",
    className: "cls-4",
    d: "M248.117,89.16l-49.087.181-.447-1.708,49.087-.181Z",
    transform: "translate(822.951 209.532)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_797",
    "data-name": "Path 797",
    className: "cls-4",
    d: "M262.577,93.466l-63.764.235-.447-1.709,63.764-.234Z",
    transform: "translate(821.988 228.724)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_798",
    "data-name": "Path 798",
    className: "cls-4",
    d: "M262.847,94.5l-63.759.234-.453-1.708,63.764-.235Z",
    transform: "translate(823.191 233.32)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_799",
    "data-name": "Path 799",
    className: "cls-4",
    d: "M263.118,95.53l-63.764.235-.447-1.708,63.764-.235Z",
    transform: "translate(824.399 237.92)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_800",
    "data-name": "Path 800",
    className: "cls-4",
    d: "M263.388,96.561l-63.764.235-.447-1.708,63.764-.235Z",
    transform: "translate(825.602 242.517)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_801",
    "data-name": "Path 801",
    className: "cls-4",
    d: "M263.658,97.593l-63.764.235-.447-1.708,63.764-.235Z",
    transform: "translate(826.805 247.115)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_802",
    "data-name": "Path 802",
    className: "cls-4",
    d: "M264.316,100.1l-63.764.235-.447-1.708,63.764-.235Z",
    transform: "translate(829.737 258.303)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_803",
    "data-name": "Path 803",
    className: "cls-4",
    d: "M264.586,101.135l-63.764.235-.447-1.708,63.764-.235Z",
    transform: "translate(830.94 262.901)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_804",
    "data-name": "Path 804",
    className: "cls-4",
    d: "M264.856,102.162l-63.764.24-.447-1.713,63.764-.229Z",
    transform: "translate(832.143 267.501)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_805",
    "data-name": "Path 805",
    className: "cls-4",
    d: "M265.122,103.2l-63.764.235-.442-1.708,63.759-.235Z",
    transform: "translate(833.351 272.095)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_806",
    "data-name": "Path 806",
    className: "cls-4",
    d: "M265.4,104.231l-63.764.235-.447-1.708,63.764-.235Z",
    transform: "translate(834.554 276.693)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_807",
    "data-name": "Path 807",
    className: "cls-1",
    d: "M324.037,225.868l-93.248.344L200.552,110.753l93.248-.344Z",
    transform: "translate(831.729 311.833)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_808",
    "data-name": "Path 808",
    className: "cls-4",
    d: "M245.7,114.585l-39.1.147-.447-1.713,39.1-.142Z",
    transform: "translate(856.7 322.83)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_809",
    "data-name": "Path 809",
    className: "cls-4",
    d: "M255,115.455l-49.087.18-.447-1.708,49.087-.18Z",
    transform: "translate(853.639 326.707)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_810",
    "data-name": "Path 810",
    className: "cls-4",
    d: "M269.464,119.762,205.7,120l-.447-1.708,63.764-.235Z",
    transform: "translate(852.676 345.899)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_811",
    "data-name": "Path 811",
    className: "cls-4",
    d: "M269.73,120.794l-63.758.235-.447-1.708,63.759-.235Z",
    transform: "translate(853.884 350.498)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_812",
    "data-name": "Path 812",
    className: "cls-4",
    d: "M270.005,121.825l-63.764.235-.447-1.708,63.758-.235Z",
    transform: "translate(855.087 355.092)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_813",
    "data-name": "Path 813",
    className: "cls-4",
    d: "M270.275,122.857l-63.764.235-.447-1.708,63.764-.235Z",
    transform: "translate(856.29 359.69)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_814",
    "data-name": "Path 814",
    className: "cls-4",
    d: "M270.545,123.889l-63.764.235-.447-1.708,63.764-.235Z",
    transform: "translate(857.493 364.289)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_815",
    "data-name": "Path 815",
    className: "cls-4",
    d: "M271.2,126.4l-63.764.235-.447-1.708,63.764-.235Z",
    transform: "translate(860.425 375.478)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_816",
    "data-name": "Path 816",
    className: "cls-4",
    d: "M271.473,127.432l-63.764.235-.447-1.708,63.764-.235Z",
    transform: "translate(861.628 380.076)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_817",
    "data-name": "Path 817",
    className: "cls-4",
    d: "M271.739,128.463l-63.758.24-.447-1.713,63.758-.235Z",
    transform: "translate(862.836 384.67)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_818",
    "data-name": "Path 818",
    className: "cls-4",
    d: "M272.013,129.495l-63.764.235-.447-1.708,63.764-.235Z",
    transform: "translate(864.035 389.269)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_819",
    "data-name": "Path 819",
    className: "cls-4",
    d: "M272.284,130.532l-63.764.235-.447-1.708,63.764-.24Z",
    transform: "translate(865.242 393.868)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_820",
    "data-name": "Path 820",
    className: "cls-1",
    d: "M330.975,252.341l-93.254.344L207.485,137.226l93.248-.344Z",
    transform: "translate(862.622 429.796)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_821",
    "data-name": "Path 821",
    className: "cls-4",
    d: "M252.634,141.058l-39.1.142-.447-1.708,39.1-.142Z",
    transform: "translate(887.593 440.793)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_822",
    "data-name": "Path 822",
    className: "cls-4",
    d: "M261.937,141.928l-49.087.18L212.4,140.4l49.087-.18Z",
    transform: "translate(884.532 444.67)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_823",
    "data-name": "Path 823",
    className: "cls-4",
    d: "M276.393,146.239l-63.759.235-.447-1.713,63.758-.235Z",
    transform: "translate(883.574 463.857)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_824",
    "data-name": "Path 824",
    className: "cls-4",
    d: "M276.667,147.266,212.9,147.5l-.447-1.708,63.764-.235Z",
    transform: "translate(884.773 468.456)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_825",
    "data-name": "Path 825",
    className: "cls-4",
    d: "M276.938,148.3l-63.764.235-.447-1.708,63.764-.235Z",
    transform: "translate(885.98 473.055)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_826",
    "data-name": "Path 826",
    className: "cls-4",
    d: "M277.208,149.33l-63.764.235L213,147.857l63.764-.235Z",
    transform: "translate(887.183 477.653)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_827",
    "data-name": "Path 827",
    className: "cls-4",
    d: "M277.478,150.362l-63.758.235-.453-1.708,63.764-.235Z",
    transform: "translate(888.387 482.252)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_828",
    "data-name": "Path 828",
    className: "cls-4",
    d: "M278.136,152.873l-63.764.235-.447-1.708,63.764-.235Z",
    transform: "translate(891.319 493.441)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_829",
    "data-name": "Path 829",
    className: "cls-4",
    d: "M278.406,153.9l-63.764.24-.447-1.713,63.764-.235Z",
    transform: "translate(892.522 498.035)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_830",
    "data-name": "Path 830",
    className: "cls-4",
    d: "M278.672,154.936l-63.758.235-.447-1.708,63.758-.235Z",
    transform: "translate(893.729 502.633)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_831",
    "data-name": "Path 831",
    className: "cls-4",
    d: "M278.947,155.968l-63.764.235-.447-1.708,63.764-.235Z",
    transform: "translate(894.932 507.232)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_832",
    "data-name": "Path 832",
    className: "cls-4",
    d: "M279.217,157l-63.764.235-.447-1.708,63.764-.235Z",
    transform: "translate(896.135 511.831)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_833",
    "data-name": "Path 833",
    className: "cls-1",
    d: "M550.676,488.027l-326.147,1.206-93.865-358.4L173.15,85.208l271.756-1Z",
    transform: "translate(520.31 195.081)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_834",
    "data-name": "Path 834",
    className: "cls-4",
    d: "M266.746,99.411,151.8,99.835l-1.315-5.023,114.946-.423Z",
    transform: "translate(608.632 240.446)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_835",
    "data-name": "Path 835",
    className: "cls-4",
    d: "M294.092,101.968l-144.311.531-1.315-5.022,144.311-.531Z",
    transform: "translate(599.64 251.841)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_836",
    "data-name": "Path 836",
    className: "cls-4",
    d: "M336.594,114.631l-187.445.687-1.315-5.025,187.445-.687Z",
    transform: "translate(596.819 308.255)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_837",
    "data-name": "Path 837",
    className: "cls-4",
    d: "M337.388,117.664l-187.445.687-1.315-5.02,187.445-.693Z",
    transform: "translate(600.357 321.77)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_838",
    "data-name": "Path 838",
    className: "cls-4",
    d: "M338.188,120.693l-187.445.693-1.32-5.025,187.451-.687Z",
    transform: "translate(603.895 335.289)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_839",
    "data-name": "Path 839",
    className: "cls-4",
    d: "M338.977,123.726l-187.445.693-1.315-5.025,187.445-.687Z",
    transform: "translate(607.437 348.804)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_840",
    "data-name": "Path 840",
    className: "cls-4",
    d: "M339.771,126.76l-187.445.693-1.315-5.025,187.445-.687Z",
    transform: "translate(610.976 362.324)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_841",
    "data-name": "Path 841",
    className: "cls-4",
    d: "M341.705,134.145l-187.445.693-1.315-5.025,187.445-.693Z",
    transform: "translate(619.593 395.209)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_842",
    "data-name": "Path 842",
    className: "cls-4",
    d: "M342.5,137.173l-187.445.693-1.315-5.025,187.445-.687Z",
    transform: "translate(623.131 408.728)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_843",
    "data-name": "Path 843",
    className: "cls-4",
    d: "M343.3,140.212l-187.445.687-1.32-5.025,187.451-.687Z",
    transform: "translate(626.669 422.243)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_844",
    "data-name": "Path 844",
    className: "cls-4",
    d: "M344.088,143.245l-187.445.687-1.315-5.02,187.445-.693Z",
    transform: "translate(630.212 435.758)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_845",
    "data-name": "Path 845",
    className: "cls-4",
    d: "M344.882,146.273l-187.445.693-1.315-5.025,187.445-.687Z",
    transform: "translate(633.75 449.277)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_846",
    "data-name": "Path 846",
    className: "cls-4",
    d: "M130.664,130.02l54.385-.2-11.9-45.428Z",
    transform: "translate(520.31 195.898)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_847",
    "data-name": "Path 847",
    className: "cls-18",
    d: "M225.979,192.6H492.34a37.432,37.432,0,0,1,37.5,37.4v17.89a38.316,38.316,0,0,1-38.35,38.241H225.979Z",
    transform: "translate(945.031 678.065)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_848",
    "data-name": "Path 848",
    className: "cls-19",
    d: "M767.977,231.079V245.15a41.052,41.052,0,0,1-41.089,40.969H229.353a5.942,5.942,0,0,1-5.958-5.936v-2.106a5.919,5.919,0,0,1,.453-2.275,5.984,5.984,0,0,1,1.293-1.926,6.052,6.052,0,0,1,1.931-1.288,5.965,5.965,0,0,1,2.281-.453H532.645a38.122,38.122,0,0,0,8.7-24.257V229.993a37.152,37.152,0,0,0-8.26-23.406H229.353a5.965,5.965,0,0,1-4.212-1.741,5.939,5.939,0,0,1-1.746-4.206v-2.1a5.955,5.955,0,0,1,5.958-5.942h500.04a38.477,38.477,0,0,1,38.585,38.481Z",
    transform: "translate(933.517 678.065)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_849",
    "data-name": "Path 849",
    className: "cls-8",
    d: "M766.488,220.474H540.12a37.228,37.228,0,0,0-7.033-13.885H229.353a6.069,6.069,0,0,1-2.281-.453,5.951,5.951,0,0,1-3.225-3.219,5.919,5.919,0,0,1-.453-2.275v-2.1a5.968,5.968,0,0,1,3.677-5.494,6.065,6.065,0,0,1,2.281-.447h500.04a38.566,38.566,0,0,1,37.1,27.875Z",
    transform: "translate(933.517 678.069)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_850",
    "data-name": "Path 850",
    className: "cls-20",
    d: "M225.979,201.169l36.839,1.571-36.839.949Z",
    transform: "translate(945.031 716.257)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_851",
    "data-name": "Path 851",
    className: "cls-20",
    d: "M225.979,203.859l87.645,1.571-87.645.949Z",
    transform: "translate(945.031 728.244)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_852",
    "data-name": "Path 852",
    className: "cls-21",
    d: "M550.956,282.449H268.309a37.573,37.573,0,0,1-37.619-37.515A35.281,35.281,0,0,1,266.017,209.7H550.956Z",
    transform: "translate(966.023 754.289)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_853",
    "data-name": "Path 853",
    className: "cls-18",
    d: "M638.092,282.449H316.414a36.679,36.679,0,0,1-36.73-36.631v-.295A35.868,35.868,0,0,1,315.6,209.7h322.5Z",
    transform: "translate(1184.339 754.289)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_854",
    "data-name": "Path 854",
    className: "cls-21",
    d: "M280.456,232.218H671.507a5.51,5.51,0,0,0,2.09-.415,5.427,5.427,0,0,0,1.768-1.179,5.364,5.364,0,0,0,1.184-1.762,5.447,5.447,0,0,0-5.041-7.524H280.456a5.441,5.441,0,0,0-5.041,7.524,5.365,5.365,0,0,0,1.184,1.762,5.46,5.46,0,0,0,3.857,1.593Z",
    transform: "translate(1163.467 804.134)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_855",
    "data-name": "Path 855",
    className: "cls-21",
    d: "M280.456,220.879H671.507a5.44,5.44,0,1,0,0-10.879H280.456a5.44,5.44,0,1,0,0,10.879Z",
    transform: "translate(1163.467 755.608)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_856",
    "data-name": "Path 856",
    className: "cls-20",
    d: "M380.861,216.371l-43.451,1.222,43.451.742Z",
    transform: "translate(1441.564 783.997)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_857",
    "data-name": "Path 857",
    className: "cls-20",
    d: "M429.807,213.3l-103.38,1.222,103.38.737Z",
    transform: "translate(1392.624 770.321)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_858",
    "data-name": "Path 858",
    className: "cls-4",
    d: "M326.622,213.482a16.984,16.984,0,0,1,5.9,8.26,11.706,11.706,0,0,1,.458,2.875c.246,6.825,0,22.277,0,22.277l13.084-7.726,13.045,7.726v-20.94c0-3.961-1.124-7.813-3.2-10.334a4.935,4.935,0,0,0-3.612-2.139Z",
    transform: "translate(1393.493 771.123)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_859",
    "data-name": "Path 859",
    className: "cls-21",
    d: "M326.622,213.482a16.984,16.984,0,0,1,5.9,8.26l26.21.306s-1.026-7.355-6.438-8.566Z",
    transform: "translate(1393.493 771.123)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_860",
    "data-name": "Path 860",
    className: "cls-18",
    d: "M604.141,279.927H315.356a42.76,42.76,0,0,1-42.818-42.709V214.805a41.82,41.82,0,0,1,41.875-41.76H604.141Z",
    transform: "translate(1152.496 590.937)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_861",
    "data-name": "Path 861",
    d: "M475.643,214.516v23a26.578,26.578,0,0,0,13.531,22.9,27,27,0,0,0,13.351,3.514h313.6a6.65,6.65,0,0,1,6.656,6.64v2.712a6.65,6.65,0,0,1-6.656,6.64H274.367a45.789,45.789,0,0,1-45.885-45.765V216.016a43.045,43.045,0,0,1,43.086-42.971H816.134a6.7,6.7,0,0,1,4.709,1.942,6.609,6.609,0,0,1,1.44,2.155,6.52,6.52,0,0,1,.508,2.537V182.4a6.641,6.641,0,0,1-6.656,6.634H501.564a26.013,26.013,0,0,0-19.074,8.3A25.39,25.39,0,0,0,475.643,214.516Z",
    transform: "translate(956.184 590.937)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_862",
    "data-name": "Path 862",
    className: "cls-20",
    d: "M366.148,182.84l-40.2,1.8,40.2,1.086Z",
    transform: "translate(1390.49 634.584)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_863",
    "data-name": "Path 863",
    className: "cls-20",
    d: "M411.429,178.332l-95.643,1.8,95.643,1.08Z",
    transform: "translate(1345.208 614.496)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_864",
    "data-name": "Path 864",
    className: "cls-4",
    d: "M315.966,178.6s6.312,3.394,8.4,8.964a9.961,9.961,0,0,1,.655,3.115c.349,7.4,0,24.154,0,24.154l18.638-8.38,18.588,8.38v-22.7a15.272,15.272,0,0,0-4.561-11.207,7.687,7.687,0,0,0-5.145-2.319Z",
    transform: "translate(1346.01 615.668)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_865",
    "data-name": "Path 865",
    className: "cls-21",
    d: "M315.966,178.6s6.312,3.394,8.4,8.964l37.346.327s-1.462-7.977-9.171-9.292Z",
    transform: "translate(1346.01 615.668)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_866",
    "data-name": "Path 866",
    className: "cls-21",
    d: "M281.979,169.622c16.526,28.693,37.319,39.763,37.319,39.763h86.493S269.37,147.732,281.979,169.622Z",
    transform: "translate(1190.898 554.734)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_867",
    "data-name": "Path 867",
    className: "cls-14",
    d: "M352.381,264.9a7.96,7.96,0,0,1,1.429,8.533.129.129,0,0,1-.022.038c-2.068,5.685-8.882,12.036-16.8,18.376-1.009.813-1.91,1.555-2.7,2.242-.2.18-.409.36-.6.54-.164.136-.317.284-.469.42-7.382,6.787-4.6,8.342-17.868,22.113-15.119,15.691-25.534,15.975-28.5,14.546-2.5-1.217,2.586-9.542,8.228-18.894.273-.453.54-.911.824-1.364.748-1.244,1.495-2.51,2.243-3.759,6.607-11.256,4.91-16.542,3.35-33.3-1.277-13.613-21.24-76.062-21.24-76.062l28.982-4.976s8.73,49.726,18.343,57.386c5.145,4.081,10.9,4.13,15.839,7.158.349.207.693.426,1.026.649A37.928,37.928,0,0,1,352.381,264.9Z",
    transform: "translate(1186.923 681.447)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_868",
    "data-name": "Path 868",
    className: "cls-22",
    d: "M347.526,212.191a7.96,7.96,0,0,1,1.429,8.533.128.128,0,0,1-.022.038c-2.526,5.68-9.172,12-16.826,18.316-1,.829-1.882,1.588-2.663,2.3q-.311.27-.605.54c-.158.136-.317.284-.469.42-7.382,6.787-4.6,8.342-17.863,22.113-15.124,15.691-25.534,15.975-28.5,14.546-2.51-1.217,2.586-9.542,8.228-18.894A64.422,64.422,0,0,0,317.191,240.3c9.106-11.594,15.179-26.483,21.382-35.109.349.213.693.431,1.026.649A38.128,38.128,0,0,1,347.526,212.191Z",
    transform: "translate(1191.778 734.157)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_869",
    "data-name": "Path 869",
    className: "cls-14",
    d: "M321.689,254.036c-1.79,8.92-14.54,7.425-28.786,3.961s-10.863.655-31.137-1.582-26.418-9.783-27.034-12.789c-.556-2.668,9.461-3.606,20.209-4.839q2.03-.229,4.065-.486c12.134-1.517,21.016-9.324,32.038-15.735,10.437-6.078,26.02-30.821,26.02-30.821l27.8,2.193s-14.589,22.1-20.231,31.716c-3.323,5.652-3.143,13.127-2.728,18.9A35.636,35.636,0,0,1,321.689,254.036Z",
    transform: "translate(983.936 674.264)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_870",
    "data-name": "Path 870",
    className: "cls-22",
    d: "M292.9,219.577c-14.245-3.475-10.863.655-31.137-1.588s-26.418-9.777-27.034-12.783c-.556-2.668,9.461-3.606,20.209-4.839l.1.207a57.314,57.314,0,0,0,29.037,9c13.76.333,28.328-3.6,37.826-3.443a35.4,35.4,0,0,1-.213,9.482C319.9,224.537,307.149,223.047,292.9,219.577Z",
    transform: "translate(983.936 712.683)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_871",
    "data-name": "Path 871",
    className: "cls-21",
    d: "M270.183,206.969l25.992,69.76,33.931,91.082a55.162,55.162,0,0,0,18.032-1.648c8.119-2.341,17.432-8.462,17.432-8.462s-9.422-97.8-27-153.935c-4.506-14.415-9.553-26.069-15.124-32.632C296.2,139.02,270.183,206.969,270.183,206.969Z",
    transform: "translate(1142.003 544.007)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_872",
    "data-name": "Path 872",
    className: "cls-4",
    d: "M400.564,161.737c17.034-5.478,65.6,1.555,114.39,11.081l10.219-16.8L630.555,147.8s34.776,76.913,15.735,125.918c-2.793,7.2-8.359,11.823-17.835,11.976,0,.005-1.533-.005-1.539,0s-62.722-.038-83.089-.038c-52.41,0-110.915-35.922-118.482-37.439-12.39-2.472-17.344,22.239-29.735,48.187s-116.447,114.9-116.447,114.9-16,.158-22.6-2.313c-7.1-2.657-9.706-6.111-9.706-6.111S362.165,174.089,400.564,161.737Z",
    transform: "translate(1038.045 478.455)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_873",
    "data-name": "Path 873",
    className: "cls-17",
    d: "M324.982,261.72c37.526,20.607,113.659,63.327,114.051,63.049,0,0,27.984,10.519,43.861,0,26.456-17.525,40.647-64.686-7.742-105.273-24.132-20.247-41.274-25.174-43.882-57.5-1.413-17.535-25.452-75.409-65.384-70.056-3.339.447-23.875,1.4-37.379,8.474C294.107,118.437,268.726,253.743,324.982,261.72Z",
    transform: "translate(1238.852 228.007)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_874",
    "data-name": "Path 874",
    className: "cls-14",
    d: "M307.651,167.63c-.164.1,18.463,6.449,30.919.944,11.719-5.161,20.6-24.394,20.427-24.4-5.336-.246-11.185-4.894-15.691-35.393l-2.27.813-38.17,13.7s2.766,12.211,4.556,23.843C308.928,156.892,309.735,166.249,307.651,167.63Z",
    transform: "translate(1287.637 304.556)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_875",
    "data-name": "Path 875",
    className: "cls-15",
    d: "M302.866,122.62s2.766,12.216,4.556,23.843c21.922-3.934,30.526-25.719,33.614-37.537Z",
    transform: "translate(1287.637 305.225)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_876",
    "data-name": "Path 876",
    className: "cls-14",
    d: "M323.723,188.477s52.214-6.989,47.352-39.354-1.4-55.068-34.951-51.974-38.154,16.412-39.163,27.607S310.013,189.459,323.723,188.477Z",
    transform: "translate(1261.1 251.492)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_877",
    "data-name": "Path 877",
    className: "cls-17",
    d: "M297.269,109.353S330.7,138.081,353.433,140.4s31.35-4.965,31.35-4.965a88.488,88.488,0,0,1-21.469-29.007,15.986,15.986,0,0,0-13.181-9.4C333.895,95.631,303.118,94.993,297.269,109.353Z",
    transform: "translate(1262.697 249.155)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_878",
    "data-name": "Path 878",
    className: "cls-17",
    d: "M323.149,103.344s-11.185,10.782-14.7,18.78c-3.4,7.72-4.419,26.178-1.713,33.516,0,0-17.421-33.789-7.557-50.208C309.634,88.024,323.149,103.344,323.149,103.344Z",
    transform: "translate(1257.714 252.591)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_879",
    "data-name": "Path 879",
    className: "cls-1",
    d: "M295.692,216.44c1.577,105.42.431,83.395,12,93.4,2.783,2.406,10.617,3.846,20.924,4.523C361.027,316.5,418,311.178,420.17,305.2c7.48-20.667,2.2-27.089,8.44-58.739.649-3.366,1.451-7.005,2.4-10.972,5.2-21.737,10.263-29.135-8.189-64.053-16.728-31.628-34.111-57.3-35.677-56.377-44.15,26.134-47.707,4.168-47.707,4.168S294.918,165.018,295.692,216.44Z",
    transform: "translate(1255.626 332.462)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_880",
    "data-name": "Path 880",
    className: "cls-4",
    d: "M274.947,243.037l33.931,91.082a55.161,55.161,0,0,0,18.032-1.648c8.119-2.335,17.432-8.462,17.432-8.462s-9.422-97.8-27-153.935Z",
    transform: "translate(1163.231 577.699)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_881",
    "data-name": "Path 881",
    className: "cls-1",
    d: "M375.148,115.806s-45.426,7.682-50.757,27.187-36.724,134.173-36.724,134.173,23.09,4.136,33.762-6.5,37.117-98.715,37.117-98.715Z",
    transform: "translate(1219.911 335.882)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_882",
    "data-name": "Path 882",
    className: "cls-23",
    d: "M301.718,242.874c32.414,2.15,89.391-3.175,91.557-9.155,7.48-20.667,2.2-27.089,8.44-58.739l-15.637-43.9s2.586,48.886-11.872,61.745c-14.442,12.86-59.192,24.825-66.219,35.573C304.6,233.55,302.373,238.722,301.718,242.874Z",
    transform: "translate(1282.522 403.947)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_883",
    "data-name": "Path 883",
    className: "cls-14",
    d: "M354.765,151.831s-31.977-7.1-37.139-4.267-17.77,13.138-19.347,16.723,11.485-2.723,15.735-3.857c2.755-.737,10,1.768,13.585,2.963,15.091,5.02,24.339,2.439,24.339,2.439Z",
    transform: "translate(1266.614 474.426)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_884",
    "data-name": "Path 884",
    className: "cls-1",
    d: "M334.157,115.038s42.939,2.641,57.8,23.319c20.924,29.1,62.433,153.138,38.645,169.681-26.789,18.632-121.925,4.878-121.925,4.878s-3.164-14.764,1.239-21.9,75.985-18.67,79.292-21.966-41.3-64.25-41.3-74.136S334.157,115.038,334.157,115.038Z",
    transform: "translate(1308.631 332.46)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_885",
    "data-name": "Path 885",
    className: "cls-14",
    d: "M311.651,148.647s-6.694,8.615-8.893,9.646a6.572,6.572,0,0,1-3.617.775l4.518-8.108Z",
    transform: "translate(1271.039 482.221)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_886",
    "data-name": "Path 886",
    className: "cls-14",
    d: "M317.626,147.02l-19.478,9.433a3.473,3.473,0,0,0,3.224,1.244c2.4-.109,8.451-2.319,8.451-2.319Z",
    transform: "translate(1266.614 474.971)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_887",
    "data-name": "Path 887",
    className: "cls-17",
    d: "M463.512,246.727H309.419L263.065,131.764H416.918Z",
    transform: "translate(1110.285 406.99)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_888",
    "data-name": "Path 888",
    className: "cls-17",
    d: "M271.23,152.014H474.71v4.479H273.036Z",
    transform: "translate(1146.668 497.224)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_889",
    "data-name": "Path 889",
    className: "cls-1",
    d: "M278.933,148.275c-1.162-4.043,1.184-7.316,5.232-7.316a10.509,10.509,0,0,1,9.444,7.316c1.162,4.037-1.184,7.316-5.232,7.316A10.516,10.516,0,0,1,278.933,148.275Z",
    transform: "translate(1179.667 447.963)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_890",
    "data-name": "Path 890",
    className: "cls-7",
    d: "M71.325,194.91l-3.281,2.27a7.755,7.755,0,0,1-10.758-1.948L38.2,167.772a7.7,7.7,0,0,1,1.95-10.726l4.7-3.252a1.512,1.512,0,0,1,2.35,1.511,1.488,1.488,0,0,1-.627.966l-4.7,3.252a4.692,4.692,0,0,0-1.187,6.531l19.085,27.46a4.718,4.718,0,0,0,6.547,1.184l3.281-2.27a4.684,4.684,0,0,0,1.187-6.525L58.119,167.669a1.509,1.509,0,0,1-.246-1.129,1.546,1.546,0,0,1,.217-.546,1.511,1.511,0,0,1,.41-.426,1.624,1.624,0,0,1,.541-.235,1.537,1.537,0,0,1,.59-.005,1.432,1.432,0,0,1,.549.213,1.53,1.53,0,0,1,.424.409l12.669,18.228a7.71,7.71,0,0,1-1.949,10.732Z",
    transform: "translate(102.179 503.955)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_891",
    "data-name": "Path 891",
    className: "cls-7",
    d: "M89.543,223.422l-5.883,4.065c-5.463,3.776-13.206,2.1-17.262-3.737L37.7,182.464a1.511,1.511,0,0,1,2.487-1.719l28.694,41.285c3.106,4.468,8.961,5.805,13.052,2.979l5.883-4.07c4.091-2.826,4.893-8.762,1.787-13.231l-32.683-47.03c-3.106-4.468-8.961-5.805-13.056-2.979a1.522,1.522,0,0,1-1.132.245,1.5,1.5,0,0,1-1.208-1.162,1.51,1.51,0,0,1-.01-.589,1.533,1.533,0,0,1,.217-.551,1.573,1.573,0,0,1,.41-.42c5.463-3.776,13.206-2.1,17.262,3.737l32.683,47.03C96.149,211.823,95.005,219.647,89.543,223.422Z",
    transform: "translate(104.883 502.527)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_892",
    "data-name": "Path 892",
    className: "cls-7",
    d: "M112.891,213.743l.708,5.816a11.36,11.36,0,0,1-9.92,12.625L54.747,238.11a11.378,11.378,0,0,1-12.66-9.9l-1.014-8.326a2.218,2.218,0,0,1,.056-.873,2.254,2.254,0,0,1,.388-.786,2.31,2.31,0,0,1,.662-.573,2.347,2.347,0,0,1,.832-.273,2.249,2.249,0,0,1,.873.071,2.13,2.13,0,0,1,.78.4,2.2,2.2,0,0,1,.828,1.5l1.014,8.331a6.921,6.921,0,0,0,7.706,6.018l48.93-5.92a6.914,6.914,0,0,0,6.038-7.687l-.707-5.816a6.931,6.931,0,0,0-7.705-6.023l-32.482,3.934a2.22,2.22,0,1,1-.536-4.408l32.482-3.928a11.379,11.379,0,0,1,12.661,9.892Z",
    transform: "translate(121.008 727.847)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_893",
    "data-name": "Path 893",
    className: "cls-7",
    d: "M162.67,216.622l1.269,10.426c1.178,9.679-6.324,18.583-16.724,19.838l-73.563,8.9a2.22,2.22,0,1,1-.537-4.408l73.563-8.9c7.962-.966,13.723-7.649,12.842-14.9l-1.27-10.426c-.882-7.251-8.078-12.363-16.041-11.4L58.417,215.9c-7.963.96-13.724,7.644-12.841,14.895a2.235,2.235,0,0,1-.056.873,2.177,2.177,0,0,1-.389.78,2.239,2.239,0,0,1-2.366.78,2.215,2.215,0,0,1-1.608-1.9c-1.177-9.679,6.324-18.578,16.724-19.838l83.793-10.143C152.073,200.091,161.491,206.943,162.67,216.622Z",
    transform: "translate(120.925 716.402)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_894",
    "data-name": "Path 894",
    className: "cls-24",
    d: "M220.427,86.109a6.782,6.782,0,1,0-8.162,5.029A6.767,6.767,0,0,0,220.427,86.109Z",
    transform: "translate(860.641 166.475)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_20011",
    "data-name": "Group 20011",
    className: "cls-25",
    transform: "translate(1925.577 398.2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_895",
    "data-name": "Path 895",
    className: "cls-4",
    d: "M443.727,208.31S352.454,195.582,373.792,85.8C373.792,85.8,475.775,108.592,443.727,208.31Z",
    transform: "translate(-274.374 -15.885)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_896",
    "data-name": "Path 896",
    className: "cls-26",
    d: "M443.727,208.31S352.454,195.582,373.792,85.8C373.792,85.8,475.775,108.592,443.727,208.31Z",
    transform: "translate(-274.374 -15.885)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_897",
    "data-name": "Path 897",
    className: "cls-27",
    d: "M423.191,166.827a171.737,171.737,0,0,0-6.231-16.357c-.076-.7-.18-1.4-.24-2.073-.131-1.511-.262-3.023-.376-4.553-.256-3.279-.464-6.558-.66-9.837-.387-6.553-.813-13.119-.911-19.689a.279.279,0,0,0-.278-.278.288.288,0,0,0-.2.081.268.268,0,0,0-.082.2c-.06,6.574-.153,13.136.1,19.706q.2,4.924.54,9.836c.049.729.1,1.46.153,2.185a194.287,194.287,0,0,0-18.277-31.181c-3.137-4.368-6.433-8.565-9.974-12.605-3.639-4.14-7.48-8.1-11.163-12.209-.235-.265-.633.145-.388.414a162.546,162.546,0,0,1,17.6,23.3c2.772,4.181,5.4,8.474,7.895,12.833-.284-.112-.567-.219-.829-.336-1.08-.443-2.161-.89-3.257-1.308q-3.74-1.428-7.447-2.811c-4.9-1.809-9.8-3.593-14.687-5.44-.289-.112-.491.414-.2.513,4.845,1.925,9.652,3.962,14.453,6.028q3.527,1.515,7.06,3.03c1.179.505,2.373.981,3.568,1.461a11.085,11.085,0,0,0,2.417.853c1.838,3.291,3.666,6.595,5.341,9.969a236.738,236.738,0,0,1,11.157,26.2l.655,1.888a54.092,54.092,0,0,0-7.475-3.6c-3.143-1.446-6.307-2.848-9.45-4.288-6.4-2.93-12.761-5.9-18.894-9.357a.288.288,0,0,0-.213-.022.312.312,0,0,0-.169.131.287.287,0,0,0,.109.382c6.274,3.41,12.418,7.038,18.7,10.437,3.137,1.7,6.3,3.35,9.515,4.9a29.8,29.8,0,0,0,8.577,3.421,107.961,107.961,0,0,1,5.98,25.8c1.015,12.418.906,24.928,1.195,37.373,0,.218.317.2.333,0,.911-11.288,1.419-22.686,1.468-34.013A98.473,98.473,0,0,0,423.191,166.827Z",
    transform: "translate(-258.448 2.678)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_898",
    "data-name": "Path 898",
    className: "cls-27",
    d: "M381.37,92.392a108.347,108.347,0,0,0-.906,19.362.155.155,0,0,0,.044.084.148.148,0,0,0,.186,0,.162.162,0,0,0,.049-.084c.366-6.421.415-12.834,1.168-19.217C381.965,92.156,381.408,92.04,381.37,92.392Z",
    transform: "translate(-230.682 12.556)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_899",
    "data-name": "Path 899",
    className: "cls-27",
    d: "M385.682,97.958a70.764,70.764,0,0,1-11.741-5.746c-.295-.2-.573.294-.267.484a44.71,44.71,0,0,0,11.856,5.643C385.753,98.4,385.9,98.049,385.682,97.958Z",
    transform: "translate(-261.09 12.488)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_900",
    "data-name": "Path 900",
    className: "cls-27",
    d: "M391.238,329.723c-.076-10.044-.268-20.094-.382-30.144-.191-33.374-.464-66.748-1.069-100.117q-.712-39.749-1.855-79.488a.445.445,0,0,0-.071-.2.438.438,0,0,0-.164-.136q-.057-10.852-.109-21.706c0-.182-.224-.269-.436-.265s-.442.095-.42.282l-.136,21.738a.463.463,0,0,0-.142.131.538.538,0,0,0-.065.186c-1.342,47.151-2.542,94.312-2.821,141.473-.06,9.586-.049,19.178-.093,28.764q-.483,46.125-.349,92.25c-.033,4.894-.1,9.788-.115,14.682-.1,28.153.295,56.267.306,84.4,0,1.517,1.686,2.27,3.481,2.341,2.046.082,4.228-.737,4.223-2.461,0-31.023.218-62.051.213-93.073C391.314,368.836,391.385,349.277,391.238,329.723Z",
    transform: "translate(-218.966 36.988)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_901",
    "data-name": "Path 901",
    className: "cls-4",
    d: "M486.77,149.391s-43.9-32.408-85.572-10.514S353,245.187,353,245.187s61.183,8.719,99.724-27.82C489.847,182.16,486.77,149.391,486.77,149.391Z",
    transform: "translate(-352.619 186.793)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_902",
    "data-name": "Path 902",
    className: "cls-27",
    d: "M475.55,140.886a52.694,52.694,0,0,0-25.436-3.312,37.1,37.1,0,0,0-5.379-.529c-2.079-.142-4.125-.3-6.187-.458-4.267-.333-8.539-.589-12.805-.9-8.659-.649-17.345-1.178-25.987-2.04-.311-.033-.371.507-.06.546,8.55,1.086,17.072,2.3,25.649,3.164,4.414.442,8.828.9,13.252,1.217,1.037.071,2.117.185,3.214.305-1.315.295-2.619.6-3.9.966a103.8,103.8,0,0,0-19.892,8.058c-3.459.617-6.9,1.582-10.29,2.373-5.429,1.277-10.841,2.673-16.237,4.081-10.661,2.783-21.191,5.914-31.786,8.981a.278.278,0,0,0-.147.136.292.292,0,0,0-.022.2.281.281,0,0,0,.126.158.261.261,0,0,0,.2.033c10.574-2.581,21.191-4.965,31.792-7.447,5.145-1.244,10.3-2.428,15.44-3.688,1.326-.327,2.679-.627,4.032-.927a128.358,128.358,0,0,0-31.2,27.029,168.761,168.761,0,0,0-21.688,34.078c-.153.316.289.616.469.295a165.74,165.74,0,0,1,26.243-34.318c-.191.584-.387,1.162-.573,1.746-.829,2.575-1.626,5.156-2.439,7.731-1.626,5.15-3.268,10.3-4.818,15.473-.1.344.42.464.54.136,1.85-4.992,3.606-10.023,5.38-15.037l2.6-7.393c.453-1.271.889-2.559,1.32-3.836.131-.415.284-.786.414-1.178a154.494,154.494,0,0,1,15.571-13.22,118.121,118.121,0,0,1,23.335-13.318c-.158.758-.295,1.517-.453,2.237-.415,2-.873,3.988-1.288,5.985-.857,4.141-1.659,8.277-2.493,12.445-1.659,8.462-2.679,17.034-4.272,25.507-.065.344.458.48.54.136,1.97-8.517,4.507-16.892,6.417-25.43.949-4.261,1.915-8.533,2.8-12.805.415-2,.829-4,1.217-6.007.229-1.113.491-2.226.616-3.345.8-.316,1.582-.682,2.384-.982a69.505,69.505,0,0,1,36.528-4.965,35.876,35.876,0,0,1,26.429,21.115c.414.949,1.9.36,1.664-.616a33.86,33.86,0,0,0-20.825-22.38Z",
    transform: "translate(-329.429 197.317)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_903",
    "data-name": "Path 903",
    className: "cls-27",
    d: "M372.923,141.733q-1.858,8.315-3.7,16.63a122.525,122.525,0,0,0-3.066,16.177c0,.213.294.213.355.033a124.186,124.186,0,0,0,3.743-16.286q1.62-8.209,3.224-16.417C373.528,141.531,373,141.394,372.923,141.733Z",
    transform: "translate(-294.014 232.485)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_904",
    "data-name": "Path 904",
    className: "cls-27",
    d: "M373.536,144.17c-5.592,2.826-11.016,6.04-16.854,8.353a.287.287,0,0,0-.1.055.25.25,0,0,0-.071.1.253.253,0,0,0-.027.115.293.293,0,0,0,.027.115.277.277,0,0,0,.071.093.31.31,0,0,0,.1.055.266.266,0,0,0,.115.011.369.369,0,0,0,.109-.038,179.97,179.97,0,0,0,16.755-8.642.112.112,0,0,0,.054-.076.136.136,0,0,0-.016-.093.113.113,0,0,0-.076-.055A.11.11,0,0,0,373.536,144.17Z",
    transform: "translate(-337.085 244.146)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_905",
    "data-name": "Path 905",
    className: "cls-4",
    d: "M459.782,219.608s-53.654,3.41-78.615-31.841-19.358-85.6-19.358-85.6,56.366,6.825,78.741,32.141S459.782,219.608,459.782,219.608Z",
    transform: "translate(-315.762 57.057)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_906",
    "data-name": "Path 906",
    className: "cls-27",
    d: "M468.126,256.131c-1.855-5.734-4.157-11.376-6.329-16.973q-3.118-8.1-6.673-16.019a333.921,333.921,0,0,0-16.084-31.5c-3.786-6.493-7.845-12.8-12.019-19.02-.087-.949-.278-1.893-.415-2.843-.251-1.659-.491-3.312-.753-4.97-.529-3.383-1.124-6.76-1.691-10.137-1.249-7.382-2.766-14.715-3.939-22.108-.06-.344-.611-.338-.557,0,1.08,7.295,1.817,14.638,2.843,21.944.5,3.59.971,7.18,1.517,10.765.2,1.288.42,2.586.611,3.879a385.757,385.757,0,0,0-26.543-34.307c-1.282-1.473-2.608-2.9-3.917-4.365-.131-.415-.333-.807-.5-1.222-.415-1.02-.786-2.035-1.162-3.061-.791-2.122-1.56-4.25-2.33-6.378-1.506-4.185-2.853-8.408-4-12.707-.087-.349-.616-.191-.529.153,1.086,4.392,2.226,8.773,3.514,13.105.622,2.1,1.315,4.163,2.051,6.209.126.344.256.687.388,1.031-6.864-7.453-14.016-14.627-21.246-21.72-.251-.251-.627.147-.382.415a383.409,383.409,0,0,1,38.023,46.4,34.418,34.418,0,0,0-3.972-1c-4.13-.8-8.309-1.38-12.467-1.91-8.724-1.108-17.454-2.21-26.178-3.579-.349-.055-.486.475-.131.54,8.309,1.637,16.553,3.5,24.808,5.38,3.9.889,7.807,1.659,11.731,2.422a76.179,76.179,0,0,1,9.417,2.673c.867,1.244,1.768,2.455,2.624,3.7,3.939,5.712,7.715,11.539,11.419,17.41-1.828-.36-3.656-.709-5.478-1.064q-6.236-1.2-12.467-2.231c-8.179-1.342-16.373-2.761-24.459-4.594a.279.279,0,0,0-.136.54c8.206,1.915,16.335,4.157,24.481,6.318,3.928,1.042,7.895,2,11.861,2.87,1.986.442,3.972.878,5.963,1.282a13.91,13.91,0,0,0,2.417.415q11.752,19,22,38.852,4.5,8.724,8.67,17.606c2.864,6.067,5.32,12.271,7.971,18.43C466.6,257.981,468.562,257.462,468.126,256.131Z",
    transform: "translate(-298.92 73.288)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_907",
    "data-name": "Path 907",
    className: "cls-27",
    d: "M376.965,123.469q-1.53-7.652-3.236-15.266c-.082-.349-.605-.185-.535.164q1.522,7.513,2.913,15.053a149.062,149.062,0,0,0,3.044,14.982.079.079,0,0,0,.033.049.114.114,0,0,0,.06.005.058.058,0,0,0,.049-.027.066.066,0,0,0,.016-.055A104.231,104.231,0,0,0,376.965,123.469Z",
    transform: "translate(-262.663 83.087)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_908",
    "data-name": "Path 908",
    className: "cls-27",
    d: "M381.688,116.052c-2.493-1.238-5.118-2.231-7.709-3.235-1.359-.524-2.717-1.048-4.07-1.588l-2.079-.824a9.846,9.846,0,0,1-2.264-.993c-.415-.3-.666.415-.262.475a10.005,10.005,0,0,1,2.3.933l2.029.906c1.3.578,2.608,1.162,3.917,1.735a73.79,73.79,0,0,0,7.928,3.126.286.286,0,0,0,.2-.016.3.3,0,0,0,.142-.153.3.3,0,0,0,.005-.207A.294.294,0,0,0,381.688,116.052Z",
    transform: "translate(-298.704 89.009)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_909",
    "data-name": "Path 909",
    className: "cls-4",
    d: "M389.394,173.935s32.479-60.447,81.883-69.8,79.641,41.285,79.641,41.285-36.036,45.847-81.37,53.839S389.394,173.935,389.394,173.935Z",
    transform: "translate(-190.448 60.697)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_910",
    "data-name": "Path 910",
    className: "cls-27",
    d: "M531.981,123a134.389,134.389,0,0,0-38.743.458c.737-.409,1.473-.824,2.2-1.173q5.508-2.782,10.961-5.625c7.584-3.934,15.255-8.118,23.194-11.288a.378.378,0,0,0,.1-.055.355.355,0,0,0,.065-.093.283.283,0,0,0,.022-.115.243.243,0,0,0-.022-.109.235.235,0,0,0-.065-.093.284.284,0,0,0-.1-.06.267.267,0,0,0-.115-.011.2.2,0,0,0-.109.033c-7.726,3.59-15.741,6.6-23.493,10.148-3.874,1.773-7.687,3.623-11.458,5.614-2.439,1.288-5.14,2.5-7.535,4.043a136.853,136.853,0,0,0-31.4,10.394q3.093-3.347,6.176-6.7c4.6-5.025,9.144-10.3,14.191-14.873.267-.24-.136-.622-.415-.382-5.172,4.681-10.628,9.008-15.642,13.875-2.433,2.357-4.758,4.807-7.027,7.322-1.129,1.244-2.264,2.553-3.322,3.89A129.768,129.768,0,0,0,383.208,227.3c-.071.344.415.535.529.185a148.6,148.6,0,0,1,36.315-61.232A142.873,142.873,0,0,1,486.238,128.1a145.537,145.537,0,0,1,45.677-4.141.5.5,0,0,0,.333-.131.512.512,0,0,0,.153-.322.5.5,0,0,0-.109-.338A.513.513,0,0,0,531.981,123Z",
    transform: "translate(-218.045 68.922)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_911",
    "data-name": "Path 911",
    className: "cls-26",
    d: "M548.419,116.071s-36.042,45.857-81.392,53.845c-34.58,6.111-63.028-11.867-74.578-20.7l-2.493-4.087s23.384-19.636,67.621-30.968S548.419,116.071,548.419,116.071Z",
    transform: "translate(-187.944 90.07)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_912",
    "data-name": "Path 912",
    className: "cls-27",
    d: "M422.028,104.23a123.589,123.589,0,0,0-10.966,7.2,70.1,70.1,0,0,0-9.559,8.7.3.3,0,0,0,.218.48.315.315,0,0,0,.2-.071c3.274-2.837,6.574-5.68,9.968-8.364a104.119,104.119,0,0,1,10.388-7.453.27.27,0,0,0,.126-.164.263.263,0,0,0-.016-.2.272.272,0,0,0-.158-.131A.26.26,0,0,0,422.028,104.23Z",
    transform: "translate(-136.785 66.142)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_913",
    "data-name": "Path 913",
    className: "cls-27",
    d: "M419.371,106.1c-1.833.758-3.7,1.419-5.532,2.177l-5.494,2.27c-.414.164-.207.8.191.638l5.516-2.226c1.839-.747,3.639-1.588,5.483-2.324C419.862,106.5,419.7,105.972,419.371,106.1Z",
    transform: "translate(-107.017 74.499)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_914",
    "data-name": "Path 914",
    className: "cls-4",
    d: "M388.206,138.891s8.681,59.95,53.927,80.923,100.412,0,100.412,0S520.846,90.1,388.206,138.891Z",
    transform: "translate(-195.742 171.798)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_915",
    "data-name": "Path 915",
    className: "cls-27",
    d: "M532.963,174.657c-4.157-.475-8.315-1.178-12.467-1.931q-3.045-.557-6.078-1.151c-1.031-.2-2.106-.442-3.181-.633-1.217-1.129-2.412-2.281-3.666-3.377A182.553,182.553,0,0,0,479.9,147.579a156.073,156.073,0,0,0-16.581-8.49c.278,0,.562.027.851.033,4.965.218,9.924.415,14.889.649,9.935.458,19.865.677,29.79,1.315.36.027.344-.529,0-.557-9.973-.671-19.871-1.762-29.817-2.613q-7.235-.622-14.475-1.282c-2.493-.224-4.981-.415-7.453-.649-.633-.055-1.271-.131-1.9-.2-2.581-.96-5.183-1.866-7.813-2.679A70.823,70.823,0,0,0,409.063,131c-11.387,2.9-22.746,10.35-25.692,22.293-.1.415.546.7.72.284,4.245-10,15.375-15.02,25.42-17.1A60.676,60.676,0,0,1,430,136.062a48.89,48.89,0,0,0,2.281,9.062c1.249,4.217,2.493,8.44,3.776,12.652,2.564,8.419,5.4,16.755,7.895,25.2a.275.275,0,0,0,.136.147.32.32,0,0,0,.2.016.3.3,0,0,0,.158-.126.252.252,0,0,0,.033-.2c-2.1-8.413-3.874-16.908-5.909-25.338-1-4.141-2.041-8.282-3.072-12.418a70.832,70.832,0,0,0-2.281-8.522,108.24,108.24,0,0,1,11.747,2.755,173.117,173.117,0,0,1,20.5,7.486c.66,4.272,1.62,8.511,2.6,12.723,1.249,5.3,2.619,10.535,4.3,15.708a.3.3,0,0,0,.131.142.258.258,0,0,0,.191.011.241.241,0,0,0,.153-.12.272.272,0,0,0,.033-.185l-.2-.977c-1.015-4.9-2.073-9.793-3.137-14.687-.829-3.95-1.6-7.917-2.461-11.861,5.614,2.515,11.141,5.27,16.488,8.326.109,1.238.42,2.482.589,3.585.322,2.068.7,4.1,1.075,6.149.857,4.627,1.779,9.237,2.908,13.809a215.265,215.265,0,0,0,7.78,26.08.3.3,0,0,0-.06.175.311.311,0,0,0,.06.18l.256.295c.2.229.513-.038.458-.278-2.079-8.888-4.485-17.694-6.443-26.614-.977-4.447-1.964-8.9-2.859-13.373-.453-2.232-.857-4.474-1.287-6.711-.115-.627-.213-1.315-.311-2.008a190.346,190.346,0,0,1,44.592,36.244c.322.36.96-.153.666-.54a166.535,166.535,0,0,0-10.808-13.105c-2.275-2.433-4.632-4.779-7.06-7.082l.753.136q3.175.532,6.372.949c4.185.557,8.38.971,12.576,1.446C533.165,175.236,533.318,174.7,532.963,174.657Z",
    transform: "translate(-217.336 177.955)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_916",
    "data-name": "Path 916",
    className: "cls-27",
    d: "M408.01,154.25q-.106-.786-.262-1.555c-.126-.666-.453-1.3-.546-1.964v-.016c-.933-4.01-1.719-8.042-2.444-12.1-.055-.278-.5-.2-.491.082a48.815,48.815,0,0,0,3.443,15.648c.06.164.344.147.316-.049Z",
    transform: "translate(-124.174 218.691)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_917",
    "data-name": "Path 917",
    className: "cls-27",
    d: "M404.447,168.308a.265.265,0,0,0-.082-.18.279.279,0,0,0-.185-.076c-1.271-5.309-2.493-10.623-3.59-15.964-.578-2.815-1.168-5.62-1.708-8.435q-.442-2.275-.835-4.556a13.22,13.22,0,0,0-.971-3.9.279.279,0,0,0-.12-.1.262.262,0,0,0-.158-.022.267.267,0,0,0-.147.071.288.288,0,0,0-.082.136,26.094,26.094,0,0,0,1.135,8.042c.551,2.93,1.124,5.854,1.768,8.762,1.315,5.909,2.8,11.807,4.479,17.628a.316.316,0,0,0,.524.093.332.332,0,0,0,.076-.191Z",
    transform: "translate(-158.492 203.673)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_918",
    "data-name": "Path 918",
    className: "cls-27",
    d: "M430.557,137.154c-8.26-1.124-16.521-2.319-24.8-3.312-.349-.038-.486.491-.131.54,8.255,1.217,16.532,2.237,24.8,3.317C430.775,137.738,430.917,137.2,430.557,137.154Z",
    transform: "translate(-119.059 198.19)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_919",
    "data-name": "Path 919",
    className: "cls-4",
    d: "M385.962,243S358.284,121.974,488.791,73C488.791,73,524.953,232.3,385.962,243Z",
    transform: "translate(-216.68 -72.914)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_920",
    "data-name": "Path 920",
    className: "cls-27",
    d: "M414.129,139.264c.491-.31.96-.608,1.4-.848,2.471-1.354,4.916-2.737,7.376-4.107l15.14-8.437c9.968-5.551,19.794-11.323,29.822-16.758.311-.17,0-.642-.295-.472-10.044,5.443-20.269,10.54-30.379,15.864l-14.955,7.866-6.111,3.216c4.348-8.226,9-16.29,14.125-24.056,6.82-10.35,14.294-20.24,22.08-29.906a.431.431,0,0,0,.12-.318.449.449,0,0,0-.142-.31.444.444,0,0,0-.627.019,206.958,206.958,0,0,0-30.177,36.845,11.567,11.567,0,0,1,.044-1.242c.147-3.01.224-6.019.267-9.037.087-5.9-.2-11.819-.016-17.719a.279.279,0,0,0-.557,0c-.245,5.8-.944,11.592-1.277,17.421q-.253,4.355-.382,8.694c-.044,1.569-.191,3.358-.136,5.076q-4.026,6.388-7.709,12.966a224.09,224.09,0,0,0-11.665,24.371c-.131-3.014-.316-6.023-.5-9.037-.387-6.624-1.2-13.223-1.478-19.872a.278.278,0,0,0-.278-.277.278.278,0,0,0-.278.277c.136,6.624-.169,13.248.038,19.872.1,3.312.2,6.624.415,9.935.087,1.217.147,2.455.229,3.7a219.384,219.384,0,0,0-9.854,33.256,356.774,356.774,0,0,0-4.861,36.544c0,.093.125.087.142,0a196.188,196.188,0,0,1,6.924-32.583q2.422-8.569,5.15-17.035c5.434-2.546,10.634-5.726,15.877-8.624,5.445-3.005,10.923-5.945,16.384-8.925,10.879-5.949,21.748-12.005,32.992-17.263.322-.153.022-.616-.3-.472C449.3,153.017,437.83,157.9,426.661,163.49c-5.56,2.786-11.032,5.759-16.45,8.805-4.534,2.542-9.193,5.088-13.525,8.015,1.271-3.767,2.592-7.518,4.032-11.223A324.281,324.281,0,0,1,414.129,139.264Z",
    transform: "translate(-216.667 -37.817)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_921",
    "data-name": "Path 921",
    className: "cls-27",
    d: "M387.56,86.722c-.027-.356-.584-.348-.557,0,.469,6.9.7,13.806,1.435,20.7.043.385.627.385.611,0C388.81,100.488,388.068,93.624,387.56,86.722Z",
    transform: "translate(-201.103 -12.943)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_922",
    "data-name": "Path 922",
    className: "cls-27",
    d: "M418.72,90.76c-8.173,3.279-16.417,6.388-24.541,9.778-.224.1-.125.464.109.373,8.249-3.076,16.384-6.429,24.59-9.617C419.211,91.161,419.036,90.627,418.72,90.76Z",
    transform: "translate(-169.688 6.129)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_923",
    "data-name": "Path 923",
    className: "cls-27",
    d: "M419.931,80.535a215.284,215.284,0,0,0-23.21,12.419.349.349,0,0,0,.1.627.358.358,0,0,0,.262-.035c7.567-4.413,15.277-8.644,23.133-12.523C420.547,80.837,420.253,80.39,419.931,80.535Z",
    transform: "translate(-158.498 -39.465)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_924",
    "data-name": "Path 924",
    className: "cls-28",
    d: "M554.208,152.125H365.988V349.789h188.22Z",
    transform: "translate(-294.745 279.664)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_925",
    "data-name": "Path 925",
    className: "cls-27",
    d: "M373.244,164.944h-9.63v338.57h9.63Z",
    transform: "translate(-305.323 336.786)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_926",
    "data-name": "Path 926",
    className: "cls-27",
    d: "M410.539,164.944h-9.63v338.57h9.63Z",
    transform: "translate(-139.138 336.786)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_927",
    "data-name": "Path 927",
    className: "cls-27",
    d: "M392.835,164.944H383.2v338.57h9.635Z",
    transform: "translate(-218.048 336.786)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_928",
    "data-name": "Path 928",
    className: "cls-27",
    d: "M567.977,186.031H364.5V213.4h203.48Z",
    transform: "translate(-301.388 430.749)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhp);
export default __webpack_public_path__ + "static/media/WHP.46d2785e213416fa9b6ae38c36b5aead.svg";
export { ForwardRef as ReactComponent };